module.exports = "/fonts/Flaticon.svg?76180a20d7397365f6dfa08eb4e0c999";